import { Card, Box, styled } from '@mui/material';

const CardRoot = styled(Card)({
  height: '100%',
  padding: '24px',
  borderRadius: '16px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.04)',
  border: '1px solid rgba(0,0,0,0.03)',
  transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    boxShadow: '0 12px 40px rgba(0,0,0,0.06)'
  }
});

const CardTitle = styled('div')(({ subtitle }) => ({
  fontSize: '1rem',
  fontWeight: '700',
  textTransform: 'capitalize',
  marginBottom: !subtitle && '16px'
}));

const SimpleCard = ({ children, title, subtitle }) => {
  return (
    <CardRoot elevation={0}>
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
